import { useQueryFilters } from '@hooks/useQueryFilters';

export function useTabsCurrentPage(pages: ReadonlyArray<{ name: string }>): (index: number) => void {
    const { updateQueryFilterParams, getQueryFilterParams } = useQueryFilters<{ currentPage?: string }>();
    const { currentPage } = getQueryFilterParams();

    return (index: number) => {
        const name = pages[index]?.name;
        // A missing currentPage means the first page: the mount-time onTabSelect echo
        // must not navigate on deep links (react-router 7 fires what v6 swallowed).
        if (name === (currentPage ?? pages[0]?.name)) return;
        updateQueryFilterParams({ currentPage: name });
    };
}
